import { CardSkeleton, CardSkeletonInner } from './card'

export const MyAccountPageSkeleton = () => {
  return (
    <div className="flex gap-8">
      <aside
        id="sidebar"
        className="bg-cf-white rounded-2 relative hidden w-64 shrink-0 flex-col gap-12 border border-[#DADCE2] md:flex"
      >
        <div className="bg-cf-purple-600 rounded-t-2 relative h-11 w-full">
          <div className=" absolute left-[calc(50%-28px)] top-4 size-14 overflow-hidden rounded-full bg-gray-900" />
        </div>
        <div className="flex flex-col gap-4">
          <div className="bg-cf-black/5 rounded-2 h-4 w-1/2 shrink-0 animate-pulse self-center" />
          <div className="bg-cf-black/5 rounded-2 h-4 w-3/5 shrink-0 animate-pulse self-center" />
        </div>
      </aside>
      <div className="flex w-full flex-col gap-8">
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
      </div>
    </div>
  )
}

export const MyAccountPageSkeletonBody = () => {
  return (
    <div className="flex w-full flex-col gap-8">
      <CardSkeleton />
      <CardSkeleton />
      <CardSkeleton />
    </div>
  )
}

export const MyAccountPageSkeletonInner = () => {
  return (
    <div className="flex w-full flex-col gap-8">
      <CardSkeletonInner />
      <CardSkeletonInner />
      <CardSkeletonInner />
    </div>
  )
}
